import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Was Karoo rifting a precursor to disruption?`}</h2>
    <p><img parentName="p" {...{
        "src": "/reevesdotnl/c213f2b51ef81d4456cda060ff30d85e/e-versus-w.gif",
        "alt": "STASS animation"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`In Permian and Triassic times (300-200 Ma) long thin rifts were established across Africa that show both sinistral and dextral strike-slip movement. The longest rift axis is known as the Southern Trans-Africa Shear System (STASS). Was this was the first sign of Gondwana becoming unstable as a large continental entity? An Euler pole for this movement, 90 degrees distant from the rifts is constructed, NW of Africa in present-day coordinates. Euler small circles about the equator to this pole are shown in red, inscribed on the global reference frame. Some interesting observations emerge. `}</p>
    <p>{`The Bouvet mantle plume appears on this 'Euler equator'. Northwest of it, in Jurassic times, West Gondwana continues its slow movement to the northeast while, southeast of it, East Gondwana starts to separate towards the southeast. The direction of separation changes at about 155 Ma and then, 130-120 Ma, the process of fragment dispersal accelerates as both East and West Gondwana develop the proto-oceans that created the present-day margins.  Remarkably, the Euler equator remains the line of separation between the fragments of East and West Gondwana with only Madagascar and Patagonia (Hoorn) showing any 'indecision' as to which half of Gondwana to belong to.`}</p>
    <p>{`The Bouvet plume head and the triple junction in the ocean south of Africa remain firmly fixed to each other. Note that the track of Africa involves the Agulhas fault zone moving tangetially and monotonously parallel to the Euler equator line we have drawn. Is there something fundamental about our Euler equator in the global scheme of continental movements?`}</p>
    <p>{`Three phases of rifting are indicated within Africa.  The Karoo (Permian-Triassic) rifts are shown in brown, the Early Cretaceous rifts in green and the current East Africa rift system in Yellow.`}</p>
    <p><em parentName="p">{`Updated 2025 September 18`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      